export default "__VITE_ASSET__Bhhy2VLH__"